import { useState } from "react";
import { useLocation } from "react-router-dom";

/**
 * URL search param carrying the title of the automation use case the user
 * picked in the "Add Automation" modal (e.g. "SLA Findings Breach").
 */
export const AUTOMATION_TITLE_PARAM = "automation_title";

/**
 * Resolves the name shown in the wizard header breadcrumb.
 *
 * - Edit flow: the automation's own name, once it is loaded.
 * - Create flow: the use-case title passed in the URL by the Add Automation modal.
 * - Otherwise: the wizard's static default.
 *
 * The URL title is captured on the first render because `useAutomationURLData`
 * clears the query string right after reading it.
 */
export const useAutomationWizardName = (
  defaultName: string,
  automationName?: string
): string => {
  const { search } = useLocation();
  const [urlTitle] = useState(
    () => new URLSearchParams(search).get(AUTOMATION_TITLE_PARAM) ?? ""
  );

  return automationName || urlTitle || defaultName;
};

export default useAutomationWizardName;
